// components/suiro/common/TimePersonSelector.jsx
import React from 'react';
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

export const TimePersonSelector = ({
  timeValue,
  personValue,
  onTimeChange,
  onPersonChange,
  users,
  timeLabel = '時刻',
  personLabel = '担当者',
  disabled = false,
  enforcePersonWhenTime = true
}) => {
  const hasTime = !!timeValue;
  const personError = enforcePersonWhenTime && hasTime && !personValue;
  const showTimeError = enforcePersonWhenTime && !hasTime && !!personValue;

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      alignItems: 'flex-start',
      width: '100%'
    }}>
      <FormControl size="small" sx={{ minWidth: 140 }} error={showTimeError}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={timeValue ? dayjs(timeValue, 'HH:mm') : null}
            onChange={onTimeChange}
            ampm={false}
            disabled={disabled}
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                size: 'small',
                error: showTimeError,
                sx: {
                  width: 170,
                  '& .MuiInputBase-root': { height: 40, boxSizing: 'border-box' },
                  '& .MuiInputBase-input': { padding: '8px 10px' }
                }
              }
            }}
          />
          {showTimeError && (
            <FormHelperText>時刻を入力してください。</FormHelperText>
          )}
        </LocalizationProvider>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 140 }} error={personError}>
        <InputLabel>{personLabel}</InputLabel>
        <Select
          value={personValue || ''}
          label={personLabel}
          onChange={onPersonChange}
          disabled={disabled}
          sx={{ height: 40, width: 170, }}
        >
          <MenuItem value=""><em>-</em></MenuItem>
          {users.map((u) => (
            <MenuItem key={u.uuid} value={u.uuid}>
              {u.name}
            </MenuItem>
          ))}
        </Select>
        {personError && (
          <FormHelperText>担当者を選択してください。</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

// 3つの選択肢がある場合のコンポーネント
export const TimePersonPartnerSelector = ({
  timeValue,
  personValue,
  partnerValue,
  onTimeChange,
  onPersonChange,
  onPartnerChange,
  users,
  partners,
  timeLabel = '時刻',
  personLabel = '連絡者',
  partnerLabel = '担当者',
  disabled = false,
  enforcePersonWhenTime = true
}) => {
  const hasTime = !!timeValue;
  const contactError = enforcePersonWhenTime && hasTime && !personValue && !partnerValue;
  const showTimeError = enforcePersonWhenTime && !hasTime && (!!personValue || !!partnerValue);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      alignItems: 'center',
      width: '100%'
    }}>
      <FormControl size="small" sx={{ minWidth: 140 }} error={showTimeError}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={timeValue ? dayjs(timeValue, 'HH:mm') : null}
            onChange={onTimeChange}
            ampm={false}
            disabled={disabled}
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                size: 'small',
                error: showTimeError,
                sx: {
                  width: 160,
                  '& .MuiInputBase-root': { height: 40, boxSizing: 'border-box' },
                  '& .MuiInputBase-input': { padding: '8px 10px' }
                }
              }
            }}
          />
        </LocalizationProvider>
        {showTimeError && (
          <FormHelperText>時刻を入力してください。</FormHelperText>
        )}
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 170, width: 'auto' }} error={contactError}>
        <InputLabel>{personLabel}</InputLabel>
        <Select
          value={personValue || ''}
          label={personLabel}
          onChange={onPersonChange}
          disabled={disabled}
          sx={{ minWidth: 160 }}
        >
          <MenuItem value=""><em></em></MenuItem>
          {users.map((u) => (
            <MenuItem key={u.uuid} value={u.uuid}>
              {u.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 170, width: 'auto' }} error={contactError}>
        <InputLabel>{partnerLabel}</InputLabel>
        <Select
          value={partnerValue || ''}
          label={partnerLabel}
          onChange={onPartnerChange}
          disabled={disabled}
          sx={{ minWidth: 160 }}
        >
          <MenuItem value=""><em> </em></MenuItem>
          {partners.map((p) => (
            <MenuItem key={p.uuid} value={p.uuid}>
              {p.person_name}
            </MenuItem>
          ))}
        </Select>
        {contactError && (
          <FormHelperText>連絡者または担当者を選択してください。</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};